import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { ThreadListInfo } from '../partials/ThreadListInfo';

type ThreadListEditDefaultViewProps = { cleanupOldPostsEnabled: boolean; dayCount: number };

function ThreadListEditDefault({ cleanupOldPostsEnabled, dayCount }: ThreadListEditDefaultViewProps) {
  return <ThreadListInfo cleanupOldPostsEnabled={cleanupOldPostsEnabled} dayCount={dayCount} />;
}

export const ThreadListEditDefaultView = asView(ThreadListEditDefault);
export type ThreadListEditDefaultView = ComponentProps<typeof ThreadListEditDefaultView>;
